export const INVALID_URL = 'Must be a correctly formatted url';
export const INVALID_EMAIL='Must be a correctly formatted email address';
export const INVALID_PHONE='Must be a correctly formatted phone number';
export const INVALID_CURRENCY='Must be currency';

export const validationErrorMsg = {
  stringLength: 'Length must be less than or equal to {expected}',
  numberMin:  'Must be greater than or equal to {expected}.',
  numberMax:	'Must be less than or equal to {expected}.',
  stringMin: 'The field does not match minmum requirement.',
  stringMax: 'The field does not match Maximum requirement.',
  required: 'This field is required.',
  stringEmpty:'The field must not be empty.',
  url:	'The field must be a valid URL.',
  email:'Must be a correctly formatted email address',
  emailEmpty:'The field must not be empty.',
  stringPattern:'The field fails to match the required pattern.',
  numberPositive:'The field must be a positive number.',
  //number:'Must be a number or N/A' save for future --Jim
  number:'Must be a number.'
};
